class ParamsDataMapper {
  toDomain(persistenceData) {
    return {
      pagina: persistenceData?.page,
      itensPorPagina: persistenceData?.itemsPerPage,
    }
  }
}

export default new ParamsDataMapper()
